// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { Tooltip } from '../tooltips';
import { IconButton } from '../buttons';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  icon: string;
  onClick: (item?: ComparisonItem) => void;
  tooltipMessage?: string;
  offsetTop?: number;
  className?: string;
  active?: boolean;
  disabled?: boolean;
  tooltipClassName?: string;
};

const ActionBarButton = (props: Props) => {
  const { tooltipMessage, offsetTop, className, icon, onClick, active, disabled, tooltipClassName, ...rest } = props;

  return (
    <Tooltip className={tooltipClassName} message={tooltipMessage} effect="solid" offset={{ top: offsetTop }}>
      <div className={classNames('icon-button-container', className)}>
        <IconButton active={active} icon={icon} onClick={() => onClick()} disabled={disabled} />
      </div>
    </Tooltip>
  );
};

export default ActionBarButton;
